export enum QuizQuestionType {
	MCQ = 'MCQ',
	TRUE_FALSE = 'TRUE_FALSE',
	OPEN_ENDED = 'OPEN_ENDED',
	CSV='CSV'
}